<template>
  <div>
    <div class="store-search">
      <div class="store-search-info">
        <div ref="SimpleSearch" :class="isPackUnwind ? 'form-box-hide': ''" class="form-box">
          <div
            v-for="(item, index) in searchData"
            :key="index"
            :class="(index > (cardWidth - 1) && isPackUnwind === true) ? 'store-search-box-hide': ''"
            class="store-search-box"
          >
            <span v-if="!item.hide">{{ item.name }}</span>
            <div v-if="item.type === 'text'" class="store-search-input">
              <el-input v-model.trim="valueData[item.field]" placeholder="请输入" clearable @input="onInput()" />
            </div>
            <div v-if="item.type === 'number'" class="store-search-input">
              <el-input v-model.trim="valueData[item.field]" placeholder="请输入" oninput="value = value.replace(/[^\d]/g,'')" clearable @input="onInput()" />
            </div>
            <div v-if="item.type === 'select' && !item.hide" class="store-search-input">
              <el-select
                v-model.trim="valueData[item.field]"
                clearable
                :multiple="item.props.multiple"
                :collapse-tags="item.props.collapseTags"
                :filterable="item.props.filterable"
                placeholder="请选择"
                @change="onInput"
              >
                <el-option
                  v-for="oItem in item.options"
                  :key="oItem.value"
                  :label="oItem.label"
                  :value="oItem.value"
                />
              </el-select>
            </div>
            <div v-if="item.type === 'date'" class="store-search-input">
              <el-date-picker
                v-model.trim="valueData[item.field]"
                type="date"
                clearable
                placeholder="选择日期"
                :format="item.props.format"
                value-format="yyyy-MM-dd"
                @blur="onInput()"
              />
            </div>
            <div v-if="item.type === 'dateRange'" class="store-search-input">
              <el-date-picker
                v-model.trim="valueData[item.field]"
                clearable
                type="daterange"
                :range-separator="item.props.rangeSeparator"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :format="item.props.format"
                value-format="yyyy-MM-dd"
                @blur="onInput()"
              />
            </div>
            <div v-if="item.type === 'cascader'" class="store-search-input">
              <el-cascader v-model.trim="valueData[item.field]" :options="item.options" :props="item.props" :show-all-levels="item.showAllLevels" :collapse-tags="item.props.collapseTags" clearable />
            </div>
            <div v-if="item.type === 'datetime'" class="store-search-input">
              <el-date-picker
                v-model.trim="valueData[item.field]"
                type="datetime"
                placeholder="选择日期时间"
                @blur="onInput()"
              />
            </div>
            <div v-if="item.type === 'datetimerange'" class="store-search-input2">
              <el-date-picker
                v-model.trim="valueData[item.field]"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '00:00:00']"
                @blur="onInput()"
              />
            </div>
          </div>
        </div>
        <!--按钮-->
        <div class="store-btn">
          <div class="store-btn-search" @click="getSearch">
            查询
          </div>
          <div class="store-btn-reset" @click="getReset">
            重置
          </div>
          <div v-if="isUnwind" class="store-btn-reset-put-on" :class="enterStatus ? 'store-btn-reset-put-on2' : ''" @mouseenter="enterStatus = true" @mouseleave="enterStatus = false" @click="packUnwind">
            <div :class="isPackUnwind ? 'triangle-on' : ''" class="triangle" />
            <span>{{ isPackUnwind ? '展开' : '收起' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleSearch',
  props: {
    searchData: {
      type: Array,
      default: () => []
    },
    isUnwind: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cardWidth: 0, // 一行显示的个数
      isPackUnwind: false, // 展开收起
      valueData: {},
      enterStatus: false,
      tagsDialog: false
    }
  },
  mounted() {
    this.searchData.forEach(item => {
      // if (item.initialValue) {
      //   this.valueData[item.field] = item.initialValue
      // } else {
      //   this.valueData[item.field] = ''
      // }
      this.$set(this.valueData, item.field, '')
    })
    this.cardWidth = Math.floor((this.$refs.SimpleSearch.clientWidth) / 342)
    window.addEventListener('resize', () => {
      if (this.$refs.SimpleSearch) {
        const clientWidth = this.$refs.SimpleSearch.clientWidth
        this.cardWidth = Math.floor(clientWidth / 342)
      }
    })
  },
  methods: {
    onInput() {
      // this.$forceUpdate()
    },
    // 触发搜索
    searchTags(tag) {
      console.log(tag)
    },
    // 取消
    getReset() {
      this.searchData.forEach(item => {
        if (item.type === 'select' && item.props.multiple) {
          this.valueData[item.field] = []
        } else if (item.type === 'cascader' && item.props.multiple) {
          this.valueData[item.field] = []
        } else if (item.type === 'dateRange') {
          this.valueData[item.field] = []
        } else {
          this.$forceUpdate()
          this.valueData[item.field] = ''
        }
      })
      this.$emit('child-close', this.valueData)
    },
    // 查询
    getSearch() {
      const dateArr = this.valueData
      this.$emit('child-event', dateArr)
    },
    // 展开拉起
    packUnwind() {
      this.isPackUnwind = !this.isPackUnwind
    }
  }
}
</script>

<style lang="scss" scoped>
.store-search {
  overflow: hidden;
  background: rgba(247, 249, 251, 1);

  .store-search-info {
    display: flex;
    align-items: baseline;
    .form-box {
      max-width: calc(100% - 316px);
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding-bottom: 24px;
      width: auto;
      .store-search-box {
        margin-top: 24px;
        align-items: center;
        display: flex;
        justify-content: flex-start;
        >span {
          width: 100px;
          text-align: right;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #646A73;
        }
        .store-search-input {
          margin-left: 12px;
          width: 230px;
          ::v-deep .el-input__inner, .el-select, .el-cascader {
            width: 230px;
            height: auto;
            line-height: 32px;
          }
          ::v-deep .el-range-editor, .el-input__inner {
            padding: 0 10px;
          }
          ::v-deep .el-input__icon {
            line-height: 32px;
            height: auto;
          }
          ::v-deep .el-range-separator {
            height: auto;
          }
        }
        .store-search-input2 {
          margin-left: 12px;
          width: 360px;
          ::v-deep .el-input__inner, .el-select, .el-cascader {
            width: 360px;
            height: auto;
            line-height: 32px;
          }
          ::v-deep .el-range-editor, .el-input__inner {
            padding: 0 10px;
          }
          ::v-deep .el-input__icon {
            line-height: 32px;
            height: auto;
          }
          ::v-deep .el-range-separator {
            height: auto;
          }
        }
        .tags-menu {
          width: 230px;
          height: 34px;
          line-height: 32px;
          -webkit-appearance: none;
          background-color: #FFF;
          background-image: none;
          border-radius: 4px;
          border: 1px solid #DCDFE6;
          box-sizing: border-box;
          color: #606266;
          font-size: inherit;
          outline: 0;
          padding: 0 15px;
          transition: border-color .2s cubic-bezier(.645,.045,.355,1);
          display: flex;
          justify-content: space-between;
          align-items: center;
          .tags-menu-left {
            display: flex;
            justify-content: flex-start;
            >span {
              background-color: #f4f4f5;
              border-color: #e9e9eb;
              color: #909399;
              margin: 2px 0 2px 6px;
              height: 24px;
              padding: 0 8px;
              line-height: 22px;
              border-width: 1px;
              border-style: solid;
              border-radius: 4px;
              font-size: 12px;
            }
            .tags-menu-txt {
              margin: 2px 0 2px 0;
              background: none;
              font-size: 14px;
              color: #B6BDC7;
              border: none;
              padding: 0;
            }
          }
        }
      }
      .store-search-box-hide {
        display: none;
      }
    }
    .form-box-hide {
      flex-wrap: nowrap;
      overflow: hidden;
    }
    .store-btn {
      margin-top: 24px;
      width: 316px;
      text-align: center;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .store-btn-reset {
        cursor: pointer;
        width: 59px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #DFE0E3;
        background-color: #FFFFFF;
        line-height: 30px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1F2329;
        margin-left: 12px;
      }

      .store-btn-search {
        cursor: pointer;
        width: 59px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid #3370FF;
        background-color: #FFFFFF;
        line-height: 30px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-left: 30px;
        color: #3370FF;
      }
      .store-btn-reset-put-on {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 32px;
        margin-left: 38px;
        width: 56px;
        .triangle {
          cursor: pointer;
          width: 0;                           /*设置宽高为0，所以div的内容为空，从才能形成三角形尖角*/
          height: 0;
          border-bottom: 6px solid #3370FF;
          border-left: 6px solid transparent;    /*transparent 表示透明*/
          border-right: 6px solid transparent;
          transform: translateX(0);
          transition: 0.3s;
        }
        .triangle-on {
          transform: rotate(180deg);
          -webkit-transform: rotate(180deg);
          transition: 0.3s;
        }
        >span {
          cursor: pointer;
          margin-left: 8px;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3370FF;
        }
      }
      .store-btn-reset-put-on2 {
        background-color: rgba(51, 112, 255, 0.08);
        border-radius: 4px;
      }
    }
  }
}
</style>
